import { render, staticRenderFns } from "./PointStat.vue?vue&type=template&id=0ae9f32b&scoped=true&"
import script from "./PointStat.vue?vue&type=script&lang=js&"
export * from "./PointStat.vue?vue&type=script&lang=js&"
import style0 from "./PointStat.vue?vue&type=style&index=0&id=0ae9f32b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9f32b",
  null
  
)

export default component.exports